import React from "react";
import styles from "./NumberBubble.module.scss";
import classnames from "classnames";

interface NumberBubbleProps {
  value: number;
}

const MAX_LIMIT = 99;

export default function NumberBubble({ value }: NumberBubbleProps) {
  const isOverMaxLimit = value > MAX_LIMIT;
  return (
    <span
      className={classnames(styles.root, { [styles.maxLimit]: isOverMaxLimit })}
    >
      {isOverMaxLimit ? `${MAX_LIMIT}+` : value}
    </span>
  );
}
